document.addEventListener('DOMContentLoaded', () => {
    // Initialise lucide icons
    if (window.lucide && typeof lucide.createIcons === 'function') {
      lucide.createIcons();
    }

    // Dynamic year
    const yearEl = document.getElementById('year');
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    // Nav scroll background
    const navEl = document.getElementById('main-nav') || document.getElementById('anabolic-nav');
    const handleScroll = () => {
      if (!navEl) return;
      if (window.scrollY > 50) {
        navEl.classList.add('scrolled', 'shadow-md');
      }
      else {
        navEl.classList.remove('scrolled', 'shadow-md');
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    // Mobile menu toggle
    const toggleBtn  = document.getElementById('mobile-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    if (toggleBtn && mobileMenu) {
      toggleBtn.addEventListener('click', () => {
        const isOpen = !mobileMenu.classList.toggle('hidden');
        toggleBtn.innerHTML = isOpen ? '<i data-lucide="x" class="w-6 h-6"></i>' : '<i data-lucide="menu" class="w-6 h-6"></i>';
        if (window.lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons();
        }
      });
    }

    // Smooth-scroll buttons (data-scroll-to)
    document.querySelectorAll('[data-scroll-to]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const targetId = btn.dataset.scrollTo;
        const target = document.getElementById(targetId);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    // Testimonial carousel
    const track       = document.querySelector('.testimonial-track');
    if (track) {
        const slides      = document.querySelectorAll('.testimonial-slide');
        const indicators  = document.querySelectorAll('.testimonial-indicator');
        let currentIndex  = 0;

        const showSlide = idx => {
          if (!track) return;
          track.style.transform = `translateX(-${idx * 100}%)`;
          indicators.forEach((dot,i) => {
            dot.classList.toggle('bg-red-500', i === idx);
            dot.classList.toggle('scale-125', i === idx);
            dot.classList.toggle('bg-gray-300', i !== idx);
          });
          currentIndex = idx;
        };

        indicators.forEach((dot,i) => dot.addEventListener('click', () => showSlide(i)));
        
        if (slides.length > 1) {
            setInterval(() => showSlide((currentIndex + 1) % slides.length), 6000);
        }
    }
  }); 